import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { BbitWebShopService } from '@bbitgmbh/webshop.sdk';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormsModule, RouterLink, I18nPipe],
})
export class FooterComponent implements OnInit {
  webShop = inject(BbitWebShopService);

  public currentYear = DateTime.now().toFormat('yyyy');

  ngOnInit(): void {}
}
